export default __webpack_public_path__ + "static/media/1234.f1cf3252.png";